export default "__VITE_ASSET__DMb7paB0__"